import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

/** Uppercase 12px eyebrow used for sidebar groups ("WALLET", "NAVIGATION"). */
export function SectionLabel({
  className,
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'text-xs font-semibold uppercase leading-5 tracking-[0.01em] text-seeker-500',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
